module.exports = __webpack_public_path__ + "img/payment.bcf45aba.png";